import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";
import { LockPerson } from "@mui/icons-material";
import { Form, Input, useFormErrors } from "../../commons/Form/Form";
import {
  SettingList,
  Setting,
  SettingDisplay,
  SettingModder,
} from "../Common/Settings";
import authAPI from "../../../api/authentication";
import { mapAuthErrors } from "../../../api/authentication";
import routes from "../../../routes/routes";
import { useModalDispatch } from "../../commons/Modal/ModalContext";
import { useToastsDispatch } from "../../commons/Toasts/ToastsContext";

export default function Password() {
  const { t } = useTranslation(["common", "settings"]);
  document.title = t("settings:tabs.password.title");

  const modal = {
    component: <PasswordForm />,
  };

  return (
    <SettingList>
      <Setting testid={"password"}>
        <SettingDisplay
          label={t("common:password")}
          value={"*****"}
          testid={"password"}
        />
        <SettingModder icon={<LockPerson />} action={"modify"} modal={modal} />
      </Setting>
    </SettingList>
  );
}

function PasswordForm() {
  const { t } = useTranslation(["common", "settings", "account"]);
  const dispatchModal = useModalDispatch();
  const dispatchToast = useToastsDispatch();

  const keys = ["current_password", "new_password"];

  const initialData = Object.fromEntries(keys.map((key) => [key, ""]));
  const [data, setData] = useState(initialData);
  const handleDataChange = (field, value) =>
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));

  const { errors, clearErrors, setErrors } = useFormErrors(keys, "__all__");

  const handleSubmit = async () => {
    clearErrors();

    const response = await authAPI.changePassword(
      data.current_password,
      data.new_password,
    );

    if (!response.ok) {
      const data = await response.json();
      setErrors(mapAuthErrors(data.errors));
      return;
    }

    dispatchToast({
      type: "add",
      variant: "success",
      heading: t("settings:tabs.password.message.title"),
      subheading: t("settings:tabs.password.message.content"),
      testid: "PasswordChangeSuccess",
    });
    handleDataChange("new_password", "");
    handleDataChange("current_password", "");
    dispatchModal({ type: "success" });
  };

  const autoComplete = (key) => {
    const map = {
      current_password: "current-password",
      new_password: "new-password",
    };

    return map[key] || "";
  };

  const inputs = keys.map((key) => ({
    label: t(`common:${key}`),
    name: key,
    type: "password",
    value: data[key],
    onChange: (value) => handleDataChange(key, value),
    errors: errors[key],
    autoComplete: autoComplete(key),
  }));

  return (
    <div>
      <Form onSubmit={handleSubmit} errors={errors.__all__}>
        {inputs.map((input) => (
          <Input key={input.name} {...input} />
        ))}
      </Form>
      <div
        style={{
          marginTop: "1.5rem",
          textAlign: "center",
          fontWeight: "600",
          fontSize: "small",
        }}
      >
        <Link
          to={routes.Account.PasswordReset}
          onClick={() => {
            dispatchModal({ type: "success" });
          }}
        >
          {t("account:login.active.forgotPassword")}
        </Link>
      </div>
    </div>
  );
}
